import { Component, effect, HostListener, inject, model, OnInit, signal, viewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ModalComponent } from "../../../../shared/components/modals/modal/modal.component";
import { LoginFormComponent } from "../login-form/login-form.component";

@Component({
    selector: 'app-login-modal',
    imports: [ModalComponent, LoginFormComponent],
    templateUrl: './login-modal.component.html',
    styleUrl: './login-modal.component.scss'
})
export class LoginModalComponent implements OnInit {
    
    router = inject(Router);
    form = viewChild(LoginFormComponent);

    visible = model<boolean>(false);

    //TODO: Feels like a bandaid fix that is closing/preventing opening of modal if route is in login screen
    inLogin = signal<boolean>(true);

    constructor(){
        effect(() => {
            if(this.inLogin()){
                this.hide();
            }
        })
    }

    ngOnInit(): void {
        this.router.events
        .pipe(
            filter((event) => event instanceof NavigationEnd)
        )
        .subscribe({
            next: (event) => {
                if(event.url == "/" || event.url.includes("/login")){
                    this.inLogin.set(true);
                }
                else{
                    this.inLogin.set(false);
                }
            }
        })
    }
    
    show(){
        if(!this.inLogin()){
            this.visible.set(true);
        }
    }
    
    hide(){
        this.visible.set(false);
        this.form()?.form.reset();
    }
    
    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload(event: Event) {
        if(this.visible()){
            event.preventDefault();
            event.returnValue = this.showLoginWarning(); // Necessary for Chrome to show a confirmation dialog.
        }
    }
    
    showLoginWarning(): boolean{
        let confirm = window.confirm('Any unsaved data will be lost. Are you sure?');
        
        if(confirm){
            this.hide();
        }
        
        return confirm;
    }
}
